module.exports = __webpack_public_path__ + "static/media/master-shot-1.1da4df5b.webp";